import Axios from 'axios';
import Vue from 'vue';
import i18n from '../../../i18n';
import { API_HOST } from '../../../config/app-const';
import { setAccessToken } from "../../../mixins/insight/setAccessToken";
import { getUrlParams } from '../../../helpers/pagination';
import { pagination } from "../../../helpers/store";

const state = {
  category: {
    isBusy: false,
    data: null,
    pagination: { ...pagination, currentPage: pagination?.page || 0 },
    isInitiated: false,
    error: null
  },
  fullCategory: {
    isBusy: false,
    data: null,
    error: null
  }
};

const mutations = {
  LOAD_CATEGORY_BUSY: (state, payload) => {
    state.category.isBusy = payload;
  },
  SET_CATEGORY_INITIATED: (state, payload) => {
    state.category.isInitiated = payload;
  },
  LOAD_CATEGORY_SUCCESS: (state, payload) => {
    if (payload.data?.tags) {
      let tags = payload?.pagination?.currentPage > 1 ? [...state.category?.data?.tags, ...payload.data?.tags] || [] : payload.data?.tags || [];
      state.category.data = { ...payload.data, tags };
    }
    else state.category.data = payload.data;
    state.category.pagination = payload.pagination;
    state.category.error = null;
  },
  LOAD_CATEGORY_FAIL: (state, payload) => {
    state.category.data = null;
    state.category.error = payload;
  },

  LOAD_FULL_CATEGORY_BUSY: (state, payload) => {
    state.fullCategory.isBusy = payload;
  },
  LOAD_FULL_CATEGORY_SUCCESS: (state, payload) => {
    state.fullCategory.isBusy = false;
    state.fullCategory.data = payload.data;
    state.fullCategory.error = null;
  },
  LOAD_FULL_CATEGORY_FAIL: (state, payload) => {
    state.fullCategory.isBusy = false;
    state.fullCategory.data = null;
    state.fullCategory.error = payload;
  }
};

const actions = {
  /**
   * Fetches category tags/sources for the query builder.
   * @param {Object} ctx Vuex action context
   * @param {Object} payload
   * @param {boolean} [payload.silent] When true with skipCommit, does not toggle global category `isBusy` (avoids full-modal loader during paged loads).
   */
  getCategory: ({ commit, rootState }, { projectId, categoryId, filterValues, skipCommit, silent = false, pagination = {} }) => {
    const skipGlobalBusy = silent === true;
    if (!skipGlobalBusy) {
      commit('LOAD_CATEGORY_BUSY', true);
    }

    const config = {
      headers: { Authorization: setAccessToken(rootState) }
    };

    let query = '';
    if (filterValues && Object.keys(filterValues).length > 0) {
      query = '?';
      Object.keys(filterValues).map((param, i) => {
        if(filterValues[param]) query += `${param}=${filterValues[param]}${i !== Object.keys(filterValues).length - 1 ? '&' : ''}`;
      });
    }

    if(Object.keys(pagination).length) {
      let params = getUrlParams(pagination, '', false);
      query += (!query ? '?' + params : query === '?' ? params : '&' + params);
    }

    return Axios
      .get(`${API_HOST}/projects/${projectId}/queries/categories/${categoryId}${query}`, config)
      .then(response => {
        const data = response.data?.data || response.data;
        if (!skipCommit) commit('LOAD_CATEGORY_SUCCESS', data);
        commit('SET_CATEGORY_INITIATED', true);
        return data;
      })
      .catch(error => {
        Vue.notify({
          group: 'store_notifications',
          type: 'error',
          text: i18n.t('messages.request.error')
        });
        commit('SET_CATEGORY_INITIATED', false);
        console.error(error);
        commit('LOAD_CATEGORY_FAIL', error)
      })
      .finally(() => {
        if (!skipGlobalBusy) {
          commit('LOAD_CATEGORY_BUSY', false);
        }
      });
  },

  getFullCategory: ({ commit, rootState }, { projectId, categoryId, pagination }) => {
    commit('LOAD_FULL_CATEGORY_BUSY', true);

    const config = {
      headers: { Authorization: setAccessToken(rootState) }
    };

    //in this case in pagination we will only have:limit, order and sort
    let query = '';
    if(pagination) {
      query = '?';
      Object.keys(pagination).map((param, i) => {
          query += `${param}=${pagination[param]}${i !== Object.keys(pagination).length - 1 ? '&' : ''}`;
        }
      );
    }

    Axios
      .get(`${API_HOST}/projects/${projectId}/queries/categories/${categoryId}${query}`, config)
      .then(response => {
        commit('LOAD_FULL_CATEGORY_SUCCESS', response.data)
      })
      .catch(error => {
        Vue.notify({
          group: 'store_notifications',
          type: 'error',
          text: i18n.t('messages.request.error')
        });

        console.error(error);
        commit('LOAD_FULL_CATEGORY_FAIL', error)
      });
  },

  getHiddenTags: ({ commit, rootState }, { projectId, queryId, categoryId }) => {
    const config = {
      headers: { Authorization: setAccessToken(rootState) }
    };

    return Axios
      .get(`${API_HOST}/projects/${projectId}/queries/${queryId}/hidden_tags/${categoryId}`, config)
      .then(response => {
        return response.data?.data || [];
      })
      .catch(error => {
        console.error(error);
        return [];
      });
  }
};

export default {
  namespaced: true,
  state,
  mutations,
  actions
};